import { render, staticRenderFns } from "./DeliveryOptionMappingPanel.vue?vue&type=template&id=8afdf126&scoped=true"
import script from "./DeliveryOptionMappingPanel.vue?vue&type=script&lang=js"
export * from "./DeliveryOptionMappingPanel.vue?vue&type=script&lang=js"
import style0 from "./DeliveryOptionMappingPanel.vue?vue&type=style&index=0&id=8afdf126&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8afdf126",
  null
  
)

export default component.exports